import React from 'react'
import './styles/Cancel.css';

export default function Cancel() {
  return (
    <div className="cancel-container">
      <div className="cancel-card">
        <div className="icon">&#10060;</div>
        <h1>Order Canceled</h1>
        <p>Your order has been canceled. If this was a mistake, you can try again.</p>
        <button className="retry-button" onClick={() => window.location.href = '/'}>
          Try Again
        </button>
      </div>
    </div>)
}
